import {
  PlayArrow as PlayArrowIcon,
  Stop as StopIcon,
} from '@mui/icons-material';
import { Step, Stepper, styled, Typography } from '@mui/material';

export const StepContainer = styled(Step)`
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
`;

const TriggerButton = () => `
  border-radius: 50%;
  padding: 3px;
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const StopIconStyled = styled(StopIcon)(
  ({ theme }) => `
    ${TriggerButton()}
    color: ${theme.palette.primary.dark};
    border: 1px solid ${theme.palette.primary.dark};
    background-color: ${theme.palette.primary.lighter};
  `,
);

export const PlayArrowIconStyled = styled(PlayArrowIcon)(
  ({ theme }) => `
    ${TriggerButton()}
    color: ${theme.palette.primary.dark};
    border: 1px solid ${theme.palette.primary.dark};
    background-color: ${theme.palette.primary.lighter};
    padding: 2px; 
  `,
);

export const StepperContainer = styled(Stepper)(({ theme }) => ({
  '& .MuiStepConnector-line': {
    borderLeft: `1px solid ${theme.palette.primary.dark}`,
  },
}));

export const StepperText = styled(Typography)(
  ({ theme, $isActive }) => `
    ${$isActive && `background-color: ${theme.palette.brand.lightBlue}`};

    &:hover {
      background-color: ${theme.palette.brand.lightGrey};
    }
`,
);
